<template>
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2.66663 16C2.66663 10.9717 2.66663 8.45757 4.22872 6.89547C5.79082 5.33337 8.30498 5.33337 13.3333 5.33337H18.6666C23.6949 5.33337 26.2091 5.33337 27.7712 6.89547C29.3333 8.45757 29.3333 10.9717 29.3333 16C29.3333 21.0284 29.3333 23.5425 27.7712 25.1046C26.2091 26.6667 23.6949 26.6667 18.6666 26.6667H13.3333C8.30498 26.6667 5.79082 26.6667 4.22872 25.1046C2.66663 23.5425 2.66663 21.0284 2.66663 16Z"
            stroke="currentColor"
            stroke-width="1.6"
        />
        <path
            d="M8 10.6666L10.8785 13.0654C13.3274 15.1061 14.5518 16.1265 16 16.1265C17.4482 16.1265 18.6726 15.1061 21.1215 13.0654L24 10.6666"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
        />
    </svg>
</template>
